// @ts-nocheck
// @mui
import { useTheme } from '@mui/material/styles';
import { Grid, Container, Typography, Alert, Button } from '@mui/material';
// components
import Page from '../components/Page';
// sections
import { AppCurrentVisits, AppWebsiteVisits } from '../sections/@dashboard/app';
import { useGetVendorDashboardDataMutation } from '../store/api/dashboardApi';
import { useEffect, useState } from 'react';
import {
  getDashboardgraphDataStore,
  setDashboardDataStore,
  getDashboardparkingWiseDataStor,
} from '../store/state/dashboardSlice';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { setRevenue } from '../store/state/revenueSlice';
import { useGetRevenueDataMutation } from '../store/api/revenueApi';
import { getEndDate, getStartDate, GET_REVENUE_TABDATA } from '../sections/@dashboard/parkingspaces/utility';
import moment from 'moment';
import { useFindServiceProviderDetailByIdMutation } from '../store/api/serviceProviderApi';
import Loading from '../components/Loading';
import { useNavigate } from 'react-router-dom';

// ----------------------------------------------------------------------
const loginDetails = JSON.parse(localStorage.getItem('login') || '{}');
const userType = loginDetails.userType;

export default function DashboardApp() {
  const theme = useTheme();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  let currentDate = new Date();
  currentDate.setMonth(currentDate.getMonth() - 1);
  const getDashboardGraphData = useAppSelector(getDashboardgraphDataStore);
  const getDashboardparkingWiseData = useAppSelector(getDashboardparkingWiseDataStor);
  const [completedList, setCompletedList] = useState([]);
  const [monthList, setMonthList] = useState([]);
  const [currentList, setCurrentList] = useState([]);
  const [cancelList, setCancelList] = useState([]);
  const [cityList, setCityList] = useState([]);
  let toDate = new Date();
  const [getVendorDashboardData, getVendorDashboardDataResponse] = useGetVendorDashboardDataMutation();
  const token = JSON.parse(localStorage.getItem('login') || '{}') || null;
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [getRevenueData, revenueResponse] = useGetRevenueDataMutation();
  const [revenues, setRevenues] = useState([]);
  const [findServiceProviderDetailById, findByIdResponse] = useFindServiceProviderDetailByIdMutation();
  const [display, setDisplay] = useState(false);
  const [displayMessage, setDisplayMessage] = useState('');
  let day30 = moment().endOf('week').toDate();
  day30 = day30.toISOString();

  useEffect(() => {
    getRevenueData({
      token: token.token,
      payload: {
        offset: rowsPerPage,
        page: page,
        fromDate: getStartDate(GET_REVENUE_TABDATA[2]),
        toDate: getEndDate(GET_REVENUE_TABDATA[2]),
        serviceProviderId: token.serviceProviderId,
        isDisputed: 'false',
        orderBy: 'id',
        orderDir: 'desc',
      },
    });
    findServiceProviderDetailById({
      id: token.serviceProviderId,
      token: token.token,
    });
  }, []);

  useEffect(() => {
    if (findByIdResponse.isSuccess) {
      let data = findByIdResponse.data;
      if (data?.currentStatus == 'Pending') {
        setDisplay(true);
        setDisplayMessage("You're account is not approved. Please contact Spot Finder team.");
      }
    }
  }, [findByIdResponse.isSuccess]);

  useEffect(() => {
    if (revenueResponse.isSuccess) {
      dispatch(setRevenue(revenueResponse.data.revenueData));
      setRevenues(revenueResponse.data.revenueData);
    }
  }, [revenueResponse.isSuccess]);

  useEffect(() => {
    getVendorDashboardData({
      token: token.token,
      payload: {
        fromDate: currentDate,
        serviceProviderId: token.serviceProviderId,
        toDate: toDate,
      },
    });
  }, []);

  useEffect(() => {
    if (getVendorDashboardDataResponse.isSuccess) {
      dispatch(setDashboardDataStore(getVendorDashboardDataResponse.data));
    }
  }, [getVendorDashboardDataResponse.isSuccess]);

  useEffect(() => {
    if (getDashboardGraphData) {
      let month = [];
      let completed = [];
      let current = [];
      let cancel = [];
      getDashboardGraphData.map((item: any) => {
        month.push(item.month);
        completed.push(item.completedBookingCount);
        current.push(item.currentBookingCount);
        cancel.push(item.cancelledBookingCount);
      });
      setMonthList(month);
      setCompletedList(completed);
      setCurrentList(current);
      setCancelList(cancel);
    }
  }, [getDashboardGraphData]);

  useEffect(() => {
    if (getDashboardparkingWiseData) {
      let city = [];
      getDashboardparkingWiseData.map((item: any) => {
        city.push({ label: item.parkingLocationName, value: item.bookingCount });
      });
      setCityList(city);
    }
  }, [getDashboardparkingWiseData]);
  
  return (
    <Page title="Dashboard">
      <Container maxWidth="xl">
        <Typography variant="h4" sx={{ mb: 5 }}>
          Hi, Welcome back
        </Typography>
        {display && (
          <Alert variant="filled" severity="warning">
            {displayMessage}
          </Alert>
        )}
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <AppWebsiteVisits
              title="Total Bookings"
              chartLabels={monthList}
              chartData={[
                {
                  name: 'Current',
                  type: 'column',
                  fill: 'solid',
                  data: currentList,
                },
                {
                  name: 'Completed',
                  type: 'area',
                  fill: 'gradient',
                  data: completedList,
                },
                {
                  name: 'Cancelled',
                  type: 'line',
                  fill: 'solid',
                  data: cancelList,
                },
              ]}
            />
          </Grid>
          {userType !== 'UTLB' && (
            <>
          <Grid item xs={12} md={6}>
            <AppCurrentVisits
              title="Bookings by City"
              chartData={cityList}
              from="city"
              chartColors={[
                theme.palette.primary.main,
                theme.palette.chart.red[0],
                theme.palette.chart.yellow[1],
                theme.palette.chart.violet[0],
              ]}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <AppCurrentVisits
              title="Revenue by Source"
              chartData={revenues}
              from="revenues"
              chartColors={[
                theme.palette.primary.main,
                theme.palette.chart.red[0],
                theme.palette.chart.yellow[1],
                theme.palette.chart.violet[0],
              ]}
            />
          </Grid>
          </>
          )}
        </Grid>
        {getVendorDashboardDataResponse.isLoading || revenueResponse.isLoading ? <Loading /> : null}
      </Container>
    </Page>
  );
}
